import script from "./BackgroundColorTransition.vue?vue&type=script&setup=true&lang=js"
export * from "./BackgroundColorTransition.vue?vue&type=script&setup=true&lang=js"

import "./BackgroundColorTransition.vue?vue&type=style&index=0&id=98a617d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98a617d4"]])

export default __exports__